import { render, staticRenderFns } from "./TaskDrawer.vue?vue&type=template&id=43995ff3&scoped=true"
import script from "./TaskDrawer.vue?vue&type=script&lang=js"
export * from "./TaskDrawer.vue?vue&type=script&lang=js"
import style1 from "./TaskDrawer.vue?vue&type=style&index=1&id=43995ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43995ff3",
  null
  
)

export default component.exports